{
  "seo": {
    "title": "Notifications",
    "description": "Stay up to date with new activity and updates."
  },
  "title": "Notifications",
  "subtitle": "Keep track of badges, digests, and activity.",
  "filters": {
    "showAll": "Show all",
    "unreadOnly": "Unread only"
  },
  "actions": {
    "markAllRead": "Mark all read"
  },
  "states": {
    "loading": "Loading notifications...",
    "empty": "No notifications yet."
  }
}
